<template>
  <va-card :title="$t('menu.vehicle_bays') + ' ' + this.$route.params.name">
    <va-button
      small
      inline
      color="#ff842b"
      icon="fa fa-chevron-left"
      class="ma-0"
      to="/admin/tables/vehicles"
    >
      {{ $t('menu.back') }}
    </va-button>
    <va-data-table 
      :fields="fields" 
      :data="data" 
      :per-page="20"
    >
    </va-data-table>
  </va-card>
</template>

<script>
import VehicleAPI from '@/services/VehicleAPI'

export default {
  data () {
    return {
      data: [],
    }
  },
  mounted () {
    let vehicleId = this.$route.params.vehicleId
    VehicleAPI.getVehicleById(vehicleId).then(response => {
      this.data = response.data.vehicle.bays
    })
  },
  methods: {
  },
  computed: {
    fields () {
      return [
        {
          name: 'name',
          title: this.$t('tables.vehicle_bays.label'),
          width: '3%',
        },
        {
          name: 'name_bay_type',
          title: this.$t('tables.vehicle_bays.bay_type'),
          width: '10%',
        },
        {
          name: 'width',
          title: this.$t('tables.vehicle_bays.bay_width'),
          width: '10%',
        },
        {
          name: 'height',
          title: this.$t('tables.vehicle_bays.bay_heigth'),
          width: '10%',
        },
        {
          name: 'length',
          title: this.$t('tables.vehicle_bays.bay_length'),
          width: '10%',
        },
      ]
    },
  }
}
</script>

<style lang="scss"></style>
